import {
  Box,
  Button,
  Flex,
  Text,
  ButtonGroup,
  Grid,
  GridItem,
  Textarea,
  Input,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Portal,
  VisuallyHidden,
  Tooltip,
  Badge,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Link,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Stack,
} from "@chakra-ui/react";
import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import {
  FileIcon,
  RemoveIcon,
  CommentBlackIcon,
  CommentIcon,
  Loader,
} from "../../assets/svgs/Icons";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import { useParams } from "react-router-dom";
import { CheckIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  approveApplication,
  getIncomingApplicationById,
  getIncomingRenewApplicationById,
  moveToAuditor,
  moveToPlanner,
  postAssignToMe,
  rejectApplication,
} from "./CertifierSlice";
import moment from "moment";
import axios from "axios";
import isAllowed from "../../routing/isAllowed";
import RC from "../../Components/Certificates/RC";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { DocumentViewer } from "../../Components/common/DocumentViewer";
import { DocumentViewerLink } from "../../Components/common/DocumentViewerLink";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import DOCUMENT_FROM from "../../Common/Constants";
import { checkFileTypesAndSize } from "../../Common/utils";
import CustomAlertDialog from "../../Components/CustomAlertDialog";

function RCRenewCertifierDetails() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [comment, setComment] = useState("");
  const [remark, setRemark] = useState("");
  const [backDate, setBackDate] = useState("");
  const [status, setStatus] = useState("idle");
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const applicationRenewStatus = "renew";
  const { renewApplication: application } = useSelector(
    (state) => state.certifier
  );
  const [checklistFile, setChecklistFile] = useState(null);
  const [remarks, setRemarks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isOpenMod, setIsOpenMod] = useState(false);

  const onCloseMod = () => setIsOpenMod(false);

  const handleSave = () => {
    onClose();
  };

  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);

  const handleGoBack = () => {
    navigate("/certifier");
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    const result = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!result.isValid) {
      setErrorMessage(result.error);
      toast.error(result.error);
      return;
    }

    setChecklistFile(file);
    toast.success("Checklist document uploaded successfully");
    setErrorMessage("");
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const handleMoveToPending = async (unitId) => {
    let values = {
      comment: comment,
    };
    try {
      setStatus("pending");
      await dispatch(moveToAuditor({ unitId: unitId, values }));
      setStatus("success");
    } catch (error) {
      setStatus("failed");
    }
    navigate(-1);
  };

  const handleMoveToPlanner = async (companyId) => {
    if (!remark || remark === "") {
      return toast.info("Please add a remark");
    }

    let values = {
      comment: remark,
    };
    try {
      setStatus("pending");
      await dispatch(
        moveToPlanner({ companyId: companyId, values, type: "SCOPE" })
      );
      setStatus("success");
    } catch (error) {
      setStatus("failed");
      console.error(error);
    }
    setSecOpen(false);
    navigate("/certifier");
  };

  const handleAssignToMe = async (companyId) => {
    try {
      setStatus("pending");
      const result = await dispatch(
        postAssignToMe({ companyId, applicationRenewStatus })
      );
      setStatus("success");
    } catch (error) {
      setStatus("failed");
      console.error(error);
    }
    navigate(-1);
  };

  const token = localStorage.getItem("cu_user");

  const handleSubmit = async (status) => {
    onCloseMod();

    const checklistFormData = new FormData();

    if (!checklistFile) {
      return toast.info("Please upload checklist document");
    }

    checklistFormData.append("document", checklistFile);
    checklistFormData.append("doc_type", "CHECK-LIST");
    checklistFormData.append("userType", "ADMIN");
    checklistFormData.append("documentInfo", "CHECK-LIST");

    try {
      const checklistFileRequest = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_HOST}/api/document`,
        data: checklistFormData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (checklistFileRequest.data) {
        const values = {
          comment: remark,
          ...(backDate && {
            rcInitiationDate: moment(backDate).format("YYYY-MM-DD"),
          }),
          checkList: checklistFileRequest?.data?.data?.id,
        };

        if (status === "APPROVE") {
          dispatch(approveApplication({ id: id, values, type: "RENEW" }));
          navigate("/certifier");
        }
        if (status === "REJECT") {
          dispatch(rejectApplication({ id: id, values, type: "RENEW" }));
          navigate("/certifier");
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }

    onModalClose();
  };

  const [loadError, setLoadError] = useState(null);
  const [retrying, setRetrying] = useState(false);

  const getList = async (id) => {
    try {
      setStatus("pending");
      setLoadError(null);
      const result = await dispatch(getIncomingRenewApplicationById(id));
      if (result?.payload) {
        setStatus("success");
      } else if (result?.error) {
        setLoadError("Failed to load application. Please try again.");
        setStatus("failed");
      }
    } catch (error) {
      setLoadError(
        "Failed to load application. Token may have expired. Please refresh the page."
      );
      setStatus("failed");
      console.error(error);
    }
  };

  const handleRetry = () => {
    setRetrying(true);
    getList(encodeURIComponent(id));
    setTimeout(() => setRetrying(false), 1000);
  };

  const [open, setOpen] = useState(false);
  const [secOpen, setSecOpen] = useState(false);

  const onSecModalCLose = () => setSecOpen(false);
  const onModalClose = () => setOpen(false);

  useEffect(() => {
    const remarks = application?.remarks?.filter((data) => data.comment);
    setRemarks(remarks);
  }, []);

  useEffect(() => {
    getList(encodeURIComponent(id));
  }, [dispatch, id]);

  return (
    <Box
      marginBottom={"2rem"}
      padding={{ base: "1rem", md: "2rem", lg: "3rem" }}
      w={"100%"}
    >
      {/* Error Message Display */}
      {loadError && status === "failed" && (
        <Box
          bg="red.50"
          border="1px solid"
          borderColor="red.200"
          borderRadius="md"
          p="4"
          mb="4"
          color="red.800"
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Text>{loadError}</Text>
            <Button
              size="sm"
              colorScheme="red"
              variant="outline"
              onClick={handleRetry}
              isLoading={retrying}
            >
              Retry
            </Button>
          </Flex>
        </Box>
      )}
      {/* Back Button */}
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>

      {/* Page Title */}
      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Registration Certificate
        </Text>
      </Box>

      {/* Application Banner */}
      <Box
        marginTop={"1.5rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        mx={{ base: "-1rem", md: "-2rem", lg: "-3rem" }}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
        fontSize={{ base: "sm", md: "md" }}
        wordBreak="break-word"
      >
        Application Form &nbsp; {application?.id}
      </Box>

      {/* Applicant Details Card */}
      <Box
        bg="#fff"
        padding={{ base: "1rem", md: "2rem" }}
        marginTop="2rem"
        borderRadius={"15px"}
      >
        {/* Approval Alert */}
        {application?.status !== "INCOMING" &&
          application?.company_approvedBy?._id && (
            <Box marginTop={"10px"} marginBottom="1rem">
              <Alert status="success" borderRadius={"10px"}>
                <AlertIcon />
                <AlertTitle fontSize={{ base: "sm", md: "md" }}>
                  This application was approved by{" "}
                  {application?.company_approvedBy?._id === userData?._id
                    ? "You"
                    : application?.company_approvedBy?.name}
                </AlertTitle>
                <AlertDescription></AlertDescription>
              </Alert>
            </Box>
          )}

        {/* Section Header */}
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
        >
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details
        </Text>

        <Box paddingLeft={{ base: "1rem", md: "3rem" }}>
          <Box
            display={"flex"}
            flexDirection="column"
            alignItems="flex-start"
            marginTop={"1rem"}
          >
            {/* Organisation Name */}
            <Box width="100%" my={"1rem"}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Name of Organisation
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.name ? application?.name : "N/A"}
              </Text>
            </Box>

            {/* Address */}
            <Box width="100%">
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Address
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.address?.raw_address
                  ? application?.address?.raw_address
                  : "N/A"}
              </Text>
            </Box>

            {/* City / State */}
            <Grid
              width={"100%"}
              templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)" }}
              my={"1rem"}
              gap="2rem"
            >
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  City
                </Text>
                <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                  {application?.address?.city
                    ? application.address.city
                    : "N/A"}
                </Text>
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  State
                </Text>
                <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                  {application?.address?.state
                    ? application?.address?.state
                    : "N/A"}
                </Text>
              </GridItem>
            </Grid>

            {/* Pincode / Country */}
            <Grid
              width={"100%"}
              templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)" }}
              my={"1rem"}
              gap="2rem"
            >
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Pincode
                </Text>
                <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                  {application?.address?.pinCode
                    ? application?.address?.pinCode
                    : "N/A"}
                </Text>
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Country
                </Text>
                <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                  {application?.address?.country
                    ? application?.address?.country
                    : "N/A"}
                </Text>
              </GridItem>
            </Grid>
          </Box>
        </Box>

        {/* Legal Representative */}
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          marginBottom="5px"
          mt="1rem"
        >
          Legal Representative
          <Box
            border={"2px solid #2272D5"}
            width="10%"
            marginBottom={"1rem"}
          ></Box>
        </Text>
        <Box paddingLeft={{ base: "1rem", md: "3rem" }}>
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            }}
            my={"1rem"}
            gap="2rem"
          >
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Name
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.legalRepresentative?.name
                  ? application?.legalRepresentative?.name
                  : "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Contact
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.legalRepresentative?.contact
                  ? application?.legalRepresentative?.contact
                  : "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Email
              </Text>
              <Text
                color={" #464C64"}
                fontSize="sm"
                marginTop={"1rem"}
                wordBreak="break-word"
              >
                {application?.legalRepresentative?.email
                  ? application?.legalRepresentative?.email
                  : "N/A"}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* Point of Contact */}
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          marginBottom="5px"
          mt="1rem"
        >
          Point of Contact
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={{ base: "1rem", md: "3rem" }}>
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            }}
            my={"1rem"}
            gap="2rem"
          >
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Name
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.contactPerson?.name
                  ? application?.contactPerson?.name
                  : "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Contact
              </Text>
              <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                {application?.contactPerson?.contact
                  ? application?.contactPerson?.contact
                  : "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Email
              </Text>
              <Text
                color={" #464C64"}
                fontSize="sm"
                marginTop={"1rem"}
                wordBreak="break-word"
              >
                {application?.contactPerson?.email
                  ? application?.contactPerson?.email
                  : "N/A"}
              </Text>
            </GridItem>
          </Grid>

          <Box my={"1rem"}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Brief Description about Organisation
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              {application?.description ? application?.description : "N/A"}
            </Text>
          </Box>
        </Box>
      </Box>

      {/* Unit Details and Scope */}
      <Box
        bg="#fff"
        padding={{ base: "1rem", md: "2rem" }}
        marginTop="2rem"
        borderRadius={"15px"}
      >
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
        >
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Unit Details and Scope
        </Text>
        <Box>
          {application?.application_units?.map((unit) => {
            return (
              <Box paddingLeft={{ base: "0.5rem", md: "3rem" }} key={unit?._id}>
                {/*
                  FIX: Removed the outer 2-column Grid wrapping all unit content.
                  It was restricting the table to only half the card width.
                  FIX: Removed width={{ base: "100%", lg: "200%" }} from the Audit table wrapper.
                  Now everything is a single full-width column with proper horizontal scroll.
                */}
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  marginTop={"1rem"}
                >
                  {/* Facility Name */}
                  <Box width="100%" my={"1rem"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Facility/Site Name
                    </Text>
                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {unit?.name ? unit?.name : "N/A"}
                    </Text>
                  </Box>

                  {/* Unit Address */}
                  <Box width="100%">
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Address
                    </Text>
                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {unit?.address?.raw_address
                        ? unit?.address?.raw_address
                        : "N/A"}
                    </Text>
                  </Box>

                  {/* Unit City/State */}
                  <Grid
                    width={"100%"}
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      sm: "repeat(2, 1fr)",
                    }}
                    my={"1rem"}
                    gap="2rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        City
                      </Text>
                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {unit?.address?.city ? unit?.address?.city : "N/A"}
                      </Text>
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        State
                      </Text>
                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {unit?.address?.state ? unit?.address?.state : "N/A"}
                      </Text>
                    </GridItem>
                  </Grid>

                  {/* Unit Pincode/Country */}
                  <Grid
                    width={"100%"}
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      sm: "repeat(2, 1fr)",
                    }}
                    my={"1rem"}
                    gap="2rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Pincode
                      </Text>
                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {unit?.address?.pinCode
                          ? unit?.address?.pinCode
                          : "N/A"}
                      </Text>
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Country
                      </Text>
                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {unit?.address?.country
                          ? unit?.address?.country
                          : "N/A"}
                      </Text>
                    </GridItem>
                  </Grid>

                  {/* Processes */}
                  <Box width={{ base: "100%", md: "50%" }} my={"1rem"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Selected Processes
                    </Text>
                    <Menu>
                      <MenuButton
                        mt="1rem"
                        as={Button}
                        bg={"#EDF3F8"}
                        w={{ base: "100%", sm: "50%" }}
                        h={"43px"}
                      >
                        View Processes
                      </MenuButton>
                      <MenuList borderRadius={"15px"}>
                        {unit?.unit_processes &&
                        unit?.unit_processes?.length > 0 ? (
                          unit?.unit_processes?.map((p) => (
                            <MenuItem
                              key={p?._id || p?.name}
                              bg="#EDF3F8"
                              mt={"1rem"}
                              w={"90%"}
                              h={"43px"}
                              borderRadius={"15px"}
                              textAlign={"center"}
                              justifyContent="center"
                              ml={"0.5rem"}
                            >
                              {p?.name || p}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem
                            bg="#EDF3F8"
                            mt={"1rem"}
                            w={"90%"}
                            ml={"0.5rem"}
                          >
                            No processes available
                          </MenuItem>
                        )}
                      </MenuList>
                    </Menu>
                  </Box>

                  {/* Programs */}
                  <Box width={{ base: "100%", md: "50%" }} my={"1rem"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Selected Programs
                    </Text>
                    <Menu>
                      <MenuButton
                        mt="1rem"
                        as={Button}
                        bg={"#EDF3F8"}
                        w={{ base: "100%", sm: "50%" }}
                        h={"43px"}
                      >
                        View Programs
                      </MenuButton>
                      <MenuList borderRadius={"15px"}>
                        {unit?.unit_programs &&
                        unit?.unit_programs?.length > 0 ? (
                          unit?.unit_programs?.map((program) => (
                            <MenuItem
                              key={program?._id || program?.name}
                              bg="#EDF3F8"
                              mt={"1rem"}
                              w={"90%"}
                              h={"43px"}
                              borderRadius={"15px"}
                              textAlign={"center"}
                              justifyContent="center"
                              ml={"0.5rem"}
                            >
                              {program?.name || program}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem
                            bg="#EDF3F8"
                            mt={"1rem"}
                            w={"90%"}
                            ml={"0.5rem"}
                          >
                            No programs available
                          </MenuItem>
                        )}
                      </MenuList>
                    </Menu>
                  </Box>

                  {/*
                    Audit Details Table — CORE FIX:
                    - width is now 100% (was width={{ base: "100%", lg: "200%" }} — root cause of overflow)
                    - overflowX="auto" on the direct wrapper Box — this is the only scroll container
                    - TableContainer has NO overflow set
                    - minW="900px" on Table forces scroll to kick in on smaller widths
                  */}
                  <Box width={"100%"} mt={"1rem"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      margin={"1rem"}
                    >
                      Audit Details
                    </Text>
                    <Box
                      mt={"1rem"}
                      width={"100%"}
                      overflowX={"auto"}
                      className="overflow-style"
                      boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                      borderRadius={"10px"}
                    >
                      <TableContainer>
                        <Table
                          size={{ base: "sm", md: "md" }}
                          bg={"#fff"}
                          borderRadius={"15px"}
                          minW={"900px"}
                        >
                          <Thead>
                            <Tr>
                              <Th
                                color="brand.blue"
                                textTransform="capitalize"
                              ></Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Date
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Auditor
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Audit Report
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                NC Report
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Legal Documents
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Last Remark
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Status
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Add Comment
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Actions
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {unit?.unit_audits?.length ? (
                              unit?.unit_audits?.map((audit, index) => (
                                <Tr key={audit?._id || index}>
                                  <Td>{index + 1}</Td>
                                  <Td whiteSpace="nowrap">{`${moment(
                                    audit?.startDate
                                  ).format("DD-MM-YYYY")}-${moment(
                                    audit?.endDate
                                  ).format("DD-MM-YYYY")}`}</Td>
                                  <Td whiteSpace="nowrap">
                                    {audit?.audit_auditor?.name
                                      ? audit?.audit_auditor?.name
                                      : "N/A"}
                                  </Td>
                                  <Td>
                                    <DocumentViewerLink
                                      document={audit?.audit_auditReport}
                                      referenceId={application?._id}
                                      doc_from={DOCUMENT_FROM.COMPANY}
                                    />
                                  </Td>
                                  <Td>
                                    <DocumentViewerLink
                                      document={audit?.audit_ncReport}
                                      referenceId={application?._id}
                                      doc_from={DOCUMENT_FROM.COMPANY}
                                    />
                                  </Td>
                                  <Td>
                                    <DocumentViewerLink
                                      document={audit?.audit_legalDocument}
                                      referenceId={application?._id}
                                      doc_from={DOCUMENT_FROM.COMPANY}
                                    />
                                  </Td>
                                  <Td
                                    maxW="150px"
                                    whiteSpace="normal"
                                    wordBreak="break-word"
                                  >
                                    {
                                      audit?.remarks?.[
                                        audit?.remarks?.length - 1
                                      ]?.comment
                                    }
                                  </Td>
                                  <Td whiteSpace="nowrap">{audit?.status}</Td>
                                  <Td>
                                    <Box
                                      pointerEvents={
                                        application?.assignedTo === userData._id
                                          ? "auto"
                                          : "none"
                                      }
                                    >
                                      <Popover>
                                        <PopoverTrigger>
                                          <Button bg={"white"}>
                                            <CommentBlackIcon />
                                          </Button>
                                        </PopoverTrigger>
                                        <Portal>
                                          <PopoverContent>
                                            <PopoverArrow />
                                            <PopoverHeader>
                                              Add Your Comment
                                            </PopoverHeader>
                                            <PopoverCloseButton />
                                            <PopoverBody>
                                              <Box>
                                                <Textarea
                                                  placeholder="Add your Comment"
                                                  onChange={(e) =>
                                                    setComment(e.target.value)
                                                  }
                                                />
                                                <Button
                                                  mt="1rem"
                                                  bg="#52BBFF"
                                                  color="white"
                                                >
                                                  Save
                                                </Button>
                                              </Box>
                                            </PopoverBody>
                                          </PopoverContent>
                                        </Portal>
                                      </Popover>
                                    </Box>
                                  </Td>
                                  <Td>
                                    <Button
                                      bg="#A8BF87"
                                      color="#FFFFFF"
                                      w={"115px"}
                                      h={"41px"}
                                      fontSize={"12px"}
                                      disabled={
                                        application?.assignedTo !== userData._id
                                      }
                                      onClick={() =>
                                        handleMoveToPending(unit?._id)
                                      }
                                    >
                                      Move To Pending
                                    </Button>
                                  </Td>
                                </Tr>
                              ))
                            ) : (
                              <Tr>
                                <Td
                                  colSpan="10"
                                  textAlign="center"
                                  fontWeight={"700"}
                                >
                                  No details for now
                                </Td>
                              </Tr>
                            )}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
                <Box mt="2rem" w={"100%"} h={"1px"} bg="gray"></Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Product Details */}
      <Box
        bg="#fff"
        borderRadius={"15px"}
        paddingLeft={{ base: "1rem", md: "3rem" }}
        paddingRight={{ base: "1rem", md: "2rem" }}
        py="1rem"
        mt="2rem"
      >
        {application?.products?.length > 0 ? (
          <>
            <Grid
              padding={"1rem"}
              mt={"2rem"}
              templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
              gap={2}
            >
              <GridItem>
                <Text fontWeight={"700"}>Product Name</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight={"700"}>Product Category</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight={"700"}>Product Classification</Text>
              </GridItem>
            </Grid>

            {application?.products?.map((product, idx) => (
              <Grid
                key={idx}
                padding={"1rem"}
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  md: "repeat(3, 1fr)",
                }}
                gap={2}
                borderTop="1px solid #eee"
              >
                <GridItem>
                  <Text>{product?.name ? product?.name : "N/A"}</Text>
                </GridItem>
                <GridItem>
                  <Text>
                    {product?.productCategory?.name
                      ? product?.productCategory?.name
                      : "N/A"}
                  </Text>
                </GridItem>
                <GridItem>
                  <Text>
                    {product?.productClassification?.name
                      ? product?.productClassification?.name
                      : "N/A"}
                  </Text>
                </GridItem>
                <GridItem>
                  {product?.product_productComposition?.map((c, ci) => (
                    <Text key={ci}>
                      {c?.commodity}
                      {"-"} {c?.percent}
                    </Text>
                  ))}
                </GridItem>
              </Grid>
            ))}
          </>
        ) : (
          <Box mt="2rem" p={"1rem"}>
            No product details available
          </Box>
        )}
      </Box>

      {/* RC Documents */}
      <Box
        marginTop="2rem"
        marginBottom="2rem"
        bg="#fff"
        borderRadius={"15px"}
        padding={{ base: "1rem", md: "2rem" }}
      >
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          padding="0.5rem"
        >
          RC Documents
        </Text>

        {application?.company_document?.length > 0 ? (
          <DocumentViewer
            document={application?.company_document}
            referenceId={application?._id}
            doc_from={DOCUMENT_FROM.COMPANY}
          />
        ) : (
          <Box
            bg="#FFFFFF"
            w={{ base: "100%", sm: "175px" }}
            h={"125px"}
            borderRadius={"15px"}
            textAlign="center"
            display="flex"
            alignItems="center"
            mb="1rem"
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
          >
            <Text padding={"1rem"}>No Application Document Found</Text>
          </Box>
        )}
      </Box>

      {/* Remarks Table — same scroll pattern: overflowX="auto" on Box, minW on Table, nothing on TableContainer */}
      {!userData?.role?.includes("ADMIN") && (
        <Box width={"100%"} mt="2rem">
          <Text
            color={"#141D43"}
            fontSize="md"
            fontWeight={"700"}
            fontFamily={"font.roboto"}
            margin={"1rem"}
          >
            Remarks
          </Text>
          <Box width={"100%"} overflowX={"auto"} className="overflow-style">
            <TableContainer>
              <Table
                variant={"simple"}
                size={{ base: "sm", md: "md" }}
                bg={"#fff"}
                borderRadius={"15px"}
                minW={"500px"}
              >
                <Thead>
                  <Tr>
                    <Th color="brand.blue" textTransform="capitalize">
                      Sr no.
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Date Time
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Comment by
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Remarks
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {remarks?.length ? (
                    remarks.map((remark, index) => (
                      <Tr key={index}>
                        <Td>{index + 1}</Td>
                        <Td whiteSpace="nowrap">{`${moment(remark?.time).format(
                          "DD-MM-YYYY hh:mm"
                        )}`}</Td>
                        <Td whiteSpace="nowrap">
                          {remark.userId &&
                            `${remark?.userId?.name} (${remark?.userId?.id})`}
                        </Td>
                        <Td
                          maxW="200px"
                          whiteSpace="normal"
                          wordBreak="break-word"
                        >
                          {remark?.comment ? remark?.comment : "N/A"}
                        </Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                        No remarks for now
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}

      {/* Admin Logs Table */}
      {userData?.role?.includes("ADMIN") && (
        <Box width={"100%"} mt="2rem">
          <Text
            color={"#141D43"}
            fontSize="md"
            fontWeight={"700"}
            fontFamily={"font.roboto"}
            margin={"1rem"}
          >
            Logs
          </Text>
          <Box width={"100%"} overflowX={"auto"} className="overflow-style">
            <TableContainer>
              <Table
                variant={"simple"}
                size={{ base: "sm", md: "md" }}
                bg={"#fff"}
                borderRadius={"15px"}
                minW={"500px"}
              >
                <Thead>
                  <Tr>
                    <Th color="brand.blue" textTransform="capitalize">
                      Sr no.
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Date Time
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      User
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Logs
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {application?.remarks?.length ? (
                    application?.remarks?.map((remark, index) => (
                      <Tr key={index}>
                        <Td>{index + 1}</Td>
                        <Td whiteSpace="nowrap">{`${moment(remark?.time).format(
                          "DD-MM-YYYY hh:mm"
                        )}`}</Td>
                        <Td whiteSpace="nowrap">
                          {remark.userId &&
                            `${remark?.userId?.name} (${remark?.userId?.id})`}
                        </Td>
                        <Td
                          maxW="200px"
                          whiteSpace="normal"
                          wordBreak="break-word"
                        >
                          {remark?.log ? remark?.log : "N/A"}
                        </Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                        No logs for now
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}

      {/* Remark Input & Back Date — only for assigned user, non-final status */}
      {application?.status !== "APPROVE" &&
        application?.status !== "REJECT" && (
          <Box>
            {application?.assignedTo &&
              application?.assignedTo === userData._id && (
                <>
                  <Box mt={"2rem"}>
                    <Textarea
                      type="text"
                      color={"#141D43"}
                      border="none"
                      width={{ base: "100%", md: "522px" }}
                      height={"164px"}
                      bg={"#fff"}
                      placeholder="Remarks"
                      fontSize={"16px"}
                      borderRadius={"15px"}
                      fontWeight={"400"}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </Box>
                  <Box mt="2rem" mb="2rem" bg="#fff" borderRadius="15px">
                    <Box p={{ base: "1rem", md: "2rem" }}>
                      <Tooltip label="This is an optional field for you to enter the backdate for RC this application.">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                          margin={"1rem"}
                        >
                          RC backdate (Optional)
                        </Text>
                      </Tooltip>
                      <Input
                        w={{ base: "100%", md: "30%" }}
                        type="date"
                        value={backDate}
                        onChange={(e) => {
                          const selectedDate = e.target.value;
                          const currentDate = new Date()
                            .toISOString()
                            .split("T")[0];
                          if (selectedDate > currentDate) {
                            toast.error(
                              "You can only select past or current date."
                            );
                            return;
                          }
                          setBackDate(selectedDate);
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
          </Box>
        )}

      {/* Admin Uploaded Documents (post-approval/rejection) */}
      {application?.status === "APPROVE" || application?.status === "REJECT" ? (
        <Box bg="#fff" marginTop="2rem" borderRadius={"15px"}>
          <Text
            color={"#141D43"}
            fontSize={{ base: "md", md: "lg" }}
            fontWeight={"800"}
            padding="1rem"
          >
            Admin uploaded Documents
          </Text>
          <Grid
            margin={"1rem"}
            templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(6, 1fr)" }}
            gap={2}
          >
            <DocumentViewer
              document={application?.company_checkList}
              referenceId={application?._id}
              doc_from={DOCUMENT_FROM.COMPANY}
            />
          </Grid>
        </Box>
      ) : (
        <Box>
          {application?.assignedTo &&
            application?.assignedTo === userData._id && (
              <Box>
                <Grid
                  mt={"2rem"}
                  templateColumns={{
                    base: "repeat(1, 1fr)",
                    sm: "repeat(2, 1fr)",
                  }}
                  gap="1rem"
                >
                  <GridItem>
                    <Button
                      bg={"#FFFFFF"}
                      color="#141D43"
                      width={{ base: "100%", sm: "230px" }}
                      height={"164px"}
                      cursor={"pointer"}
                      borderRadius={"15px"}
                      leftIcon={<FiUpload />}
                      as="label"
                      htmlFor="file-upload"
                      variant="outline"
                    >
                      Upload checklist
                    </Button>
                  </GridItem>
                  <GridItem>
                    <VisuallyHidden>
                      <input
                        id="file-upload"
                        type="file"
                        onChange={handleFileUpload}
                      />
                    </VisuallyHidden>
                  </GridItem>
                  {checklistFile && (
                    <GridItem colSpan={1}>
                      <Box display={"flex"} className="overflow-style">
                        <Box
                          bg="#FFFFFF"
                          w={{ base: "100%", sm: "230px" }}
                          h={"164px"}
                          borderRadius={"15px"}
                          mt={"2rem"}
                        >
                          <Box display={"flex"} justifyContent={"right"}>
                            <Button
                              borderColor="#FFFFFF"
                              bg="#ffffff"
                              size="sm"
                              variant="outline"
                              onClick={() => setChecklistFile()}
                              leftIcon={<RemoveIcon />}
                            ></Button>
                          </Box>
                          <Box display={"flex"} justifyContent={"center"}>
                            <FileIcon />
                          </Box>
                          <Tooltip label={checklistFile?.name}>
                            <Text
                              margin={"auto"}
                              width={"130px"}
                              whiteSpace={"nowrap"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                            >
                              {checklistFile?.name}
                            </Text>
                          </Tooltip>
                        </Box>
                      </Box>
                    </GridItem>
                  )}
                </Grid>

                <Box mt="1rem" display={"flex"} justifyContent={"center"}>
                  {errorMessage && (
                    <Box
                      bg="crimson"
                      color="white"
                      p="1rem"
                      borderRadius="15px"
                      mb="1rem"
                      w={{ base: "100%", md: "60%" }}
                      textAlign={"center"}
                    >
                      {errorMessage}
                      <Button
                        size="sm"
                        variant="outline"
                        ml="1rem"
                        bg="white"
                        color="black"
                        onClick={clearErrorMessage}
                      >
                        <RemoveIcon />
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
        </Box>
      )}

      {/* Action Buttons */}
      {application?.status !== "REJECT" && (
        <>
          {application?.status === "APPROVE" ? (
            <Box mt={"4rem"}>
              <Button
                as={Link}
                bg="#A8BF87"
                color={"#ffffff"}
                _hover={{ bg: "#A8BF87" }}
                w={{ base: "100%", sm: "193px" }}
                h="50px"
                onClick={() => setShowPreview((prev) => !prev)}
              >
                {!showPreview ? (
                  <>
                    View RC &nbsp; <AiOutlineEye size={24} />
                  </>
                ) : (
                  <>
                    Hide View &nbsp; <AiOutlineEyeInvisible size={24} />
                  </>
                )}
              </Button>
            </Box>
          ) : (
            <Box mt="4rem">
              {!application?.assignedTo ||
              application?.assignedTo !== userData._id ? (
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  spacing={3}
                  align={{ base: "stretch", sm: "center" }}
                  flexWrap="wrap"
                >
                  <Button
                    bg="#A8BF87"
                    color="#ffffff"
                    _hover={{ bg: "#A8BF87" }}
                    w={{ base: "100%", sm: "193px" }}
                    h="50px"
                    onClick={() =>
                      handleAssignToMe(encodeURIComponent(application?.id))
                    }
                  >
                    Assign to Me
                  </Button>
                  <Box
                    bg="brand.gray"
                    boxShadow={"rgba(100, 100, 111, 0.2) 0px 20px 50px 0px"}
                    w={{ base: "100%", sm: "300px" }}
                    h={{ base: "auto", sm: "50px" }}
                    borderRadius={"15px"}
                    py={{ base: "0.5rem", sm: "0" }}
                    px="1rem"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      p={"5px"}
                      color={"#141D43"}
                      fontWeight={"800"}
                      fontFamily={"font.roboto"}
                      textAlign={"center"}
                      fontSize={{ base: "sm", md: "md" }}
                    >
                      Before performing any action, assign this application.
                    </Text>
                  </Box>
                </Stack>
              ) : (
                <Stack
                  direction={{ base: "column", md: "row" }}
                  spacing={2}
                  align={{ base: "stretch", md: "center" }}
                  flexWrap="wrap"
                >
                  <Button
                    bg="#52BBFF"
                    color="#ffffff"
                    _hover={{ bg: "#52BBFF" }}
                    w={{ base: "100%", sm: "193px" }}
                    h="50px"
                    onClick={() => setIsOpenMod(true)}
                  >
                    Approve
                  </Button>
                  <Button
                    bg="crimson"
                    color="#ffffff"
                    _hover={{ bg: "crimson" }}
                    w={{ base: "100%", sm: "193px" }}
                    h="50px"
                    onClick={() => setOpen(true)}
                  >
                    Reject
                  </Button>
                  <Button
                    bg="#52BBFF"
                    color="#ffffff"
                    _hover={{ bg: "#52BBFF" }}
                    w={{ base: "100%", sm: "193px" }}
                    h="50px"
                    onClick={() => setSecOpen(true)}
                  >
                    Return To Planner
                  </Button>
                  <Box
                    bg="brand.gray"
                    boxShadow={"rgba(100, 100, 111, 0.2) 0px 20px 50px 0px"}
                    w={{ base: "100%", sm: "300px" }}
                    h={{ base: "auto", sm: "50px" }}
                    borderRadius={"15px"}
                    py={{ base: "0.5rem", sm: "0" }}
                    px="1rem"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      p={"5px"}
                      color={"#141D43"}
                      fontWeight={"800"}
                      fontFamily={"font.roboto"}
                      textAlign={"center"}
                      fontSize={{ base: "sm", md: "md" }}
                    >
                      You are currently assigned to this application.
                    </Text>
                  </Box>
                  <Button
                    as={Link}
                    bg="#A8BF87"
                    color="#ffffff"
                    _hover={{ bg: "#A8BF87" }}
                    w={{ base: "100%", sm: "193px" }}
                    h="50px"
                    onClick={() => setShowPreview((prev) => !prev)}
                  >
                    {!showPreview ? (
                      <>
                        Preview RC &nbsp; <AiOutlineEye size={24} />
                      </>
                    ) : (
                      <>
                        Hide Preview &nbsp; <AiOutlineEyeInvisible size={24} />
                      </>
                    )}
                  </Button>
                </Stack>
              )}
            </Box>
          )}
        </>
      )}

      {/* Confirm Dialogs */}
      <CustomAlertDialog
        isOpen={open}
        onClose={onModalClose}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="red"
        onConfirm={() => handleSubmit("REJECT")}
      />

      <CustomAlertDialog
        isOpen={secOpen}
        onClose={onSecModalCLose}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="#A8BF87"
        onConfirm={() => handleMoveToPlanner(application?.id)}
      />

      <CustomAlertDialog
        isOpen={isOpenMod}
        onClose={onCloseMod}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="#52BBFF"
        onConfirm={() => handleSubmit("APPROVE")}
      />

      {/* RC Preview */}
      {showPreview && (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Spinner width="50px" height="50px" color="#3958DC" />
              <Text marginLeft="10px">Loading the RC...</Text>
            </Box>
          }
        >
          <Box marginTop={"1rem"} marginBottom="1rem">
            <RC
              application={application}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isPreview={application?.status !== "APPROVE"}
            />
          </Box>
        </Suspense>
      )}
    </Box>
  );
}

export default isAllowed(RCRenewCertifierDetails);
